import { BaseOutput } from './base-output.model'
import { has, isString } from 'lodash'

export interface AcceptConsentsOutput extends BaseOutput {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  UrlRedirect: string
}

export const isAcceptConsentsOutput = (obj: unknown): obj is AcceptConsentsOutput => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const UrlRedirect = 'UrlRedirect'

  return has(obj, UrlRedirect) && isString(obj[UrlRedirect])
}
